export const reviewReasonMap = {
  'Ongoing client service': {
    text: 'Annual review',
  },
  'Change of client circumstances': {
    text: 'Ad hoc review',
  },
  'Initial client meeting': {
    text: 'Initial review',
  },
  'Review of past advice': {
    text: 'Consolidation review',
  },
};

export function getReviewReason(review: {reviewReason: string | null}) {
  return reviewReasonMap[review.reviewReason as keyof typeof reviewReasonMap];
}
